module.exports = __webpack_public_path__ + "img/logo.f8b7340e.png";